// BOXEB2B — SEO meta tag setter for React SPA.
// Sets <title>, meta description, keywords, and Open Graph tags on mount.
// Cleans up (restores previous title) on unmount.
import { useEffect } from "react";

function upsertMeta(attr, key, value) {
    if (!value) return;
    let el = document.head.querySelector(`meta[${attr}="${key}"]`);
    if (!el) {
        el = document.createElement("meta");
        el.setAttribute(attr, key);
        document.head.appendChild(el);
    }
    el.setAttribute("content", value);
}

function upsertLink(rel, href) {
    if (!href) return;
    let el = document.head.querySelector(`link[rel="${rel}"]`);
    if (!el) {
        el = document.createElement("link");
        el.setAttribute("rel", rel);
        document.head.appendChild(el);
    }
    el.setAttribute("href", href);
}

export function useSeo({ title, description, keywords, canonical, ogImage, jsonLd } = {}) {
    useEffect(() => {
        const prevTitle = document.title;
        if (title) document.title = title;

        upsertMeta("name", "description", description);
        upsertMeta("name", "keywords", keywords);

        upsertMeta("property", "og:title", title);
        upsertMeta("property", "og:description", description);
        upsertMeta("property", "og:type", "article");
        upsertMeta("property", "og:image", ogImage);
        upsertMeta("property", "og:url", canonical || (typeof window !== "undefined" ? window.location.href : ""));

        upsertMeta("name", "twitter:card", "summary_large_image");
        upsertMeta("name", "twitter:title", title);
        upsertMeta("name", "twitter:description", description);

        if (canonical) upsertLink("canonical", canonical);

        let jsonLdEl = null;
        if (jsonLd) {
            jsonLdEl = document.createElement("script");
            jsonLdEl.type = "application/ld+json";
            jsonLdEl.textContent = JSON.stringify(jsonLd);
            document.head.appendChild(jsonLdEl);
        }

        return () => {
            document.title = prevTitle;
            if (jsonLdEl) document.head.removeChild(jsonLdEl);
        };
    }, [title, description, keywords, canonical, ogImage, jsonLd]);
}
